// atila-portfolio/src/pages/blog.tsx
import React from 'react';
import Navbar from '../components/Navbar';

interface PostType {
  id: number;
  title: string;
  date: string;
  description: string;
  imageUrl: string;
  tags: string[];
  link: string;
}


// Estrutura de dados para postagens
const Post = ({ post }: { post: PostType }) => (
  <article className="my-2 sm:m-2 lg:max-w-md">
    <div className="rounded-lg hover:bg-slate-100 dark:hover:bg-gray-700 overflow-hidden shadow-lg transition border-gray-400 dark:border-black hover:border-indigo-300 hover:border border bg-slate-50 dark:bg-gray-800">
      <a href={post.link}>
        <div
          className="h-64 relative"
          style={{
            backgroundImage: `url(${post.imageUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          <img
            alt="Card Hero"
            loading="lazy"
            decoding="async"
            className="object-cover"
            style={{ position: 'absolute', height: '100%', width: '100%', inset: '0px', color: 'transparent' }}
          />
        </div>
        <div className="px-6 py-4">
          <h2 className="font-bold text-slate-900 dark:text-white text-xl mb-2">{post.title}</h2>
          <p className="text-gray-400 text-sm mb-2">{post.date}</p>
          <p className="text-gray-700 dark:text-slate-300 text-base">{post.description}</p>
        </div>
      </a>
      <div className="px-6 pt-4 pb-2">
        {post.tags.map((tag: string, index: number) => (
          <a
            key={index}
            className="inline-block bg-gray-200 dark:bg-slate-400 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 dark:text-gray-800 mr-2 mb-2"
            href={`/blog?tag=${tag.replace('#', '')}`}
          >
            {tag}
          </a>
        ))}
      </div>
    </div>
  </article>
);

const Blog = () => {
  const posts: PostType[] = [
    {
      id: 1,
      title: 'teste',
      date: '10 de Novembro de 2024',
      description: 'teste...',
      imageUrl: '/static/images/image-dev-home.jpg',
      tags: ['#teste', '#js', '#tutorial', '#react'],
      link: '/blog/teste'
    },
  ];

  return (
    <div>
      <Navbar />
      <div className="background">
              <div id="stars"></div>
              <div id="stars2"></div>
              <div id="stars3"></div>
            </div>
      <h1>Blog</h1>
      <p>Bem-vindo ao meu blog!</p>
      <div className="flex flex-wrap justify-center">
        {posts.map(post => (
          <Post key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
};

export default Blog;